import PropTypes from 'prop-types';

export const RenewalDataPropType = PropTypes.shape({
  PetName: PropTypes.string,
  FullPolicyNumber: PropTypes.string,
  RenewalStartDate: PropTypes.string,
  RenewalEndDate: PropTypes.string,
  LevelOfCover: PropTypes.string,
  BenefitPercentage: PropTypes.number,
  Excess: PropTypes.number,
  ExcessType: PropTypes.string,
  RoutineCare: PropTypes.bool,
  BoosterCare: PropTypes.bool,
  PaymentFrequency: PropTypes.string,
  PaymentAmount: PropTypes.number,
  PremiumAnnual: PropTypes.number,
  AnnualBenefitLimit: PropTypes.number
});
